/* src/app/components/userandgroup/user/userlist/userlist.component.scss */
:host {
  width: 100%;
  height: 100vh;
}
.scroll-bar {
  height: calc(100vh - 120px);
  overflow-y: auto;
}
.card-image {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
.flex-item {
  width: 265px !important;
}
/*# sourceMappingURL=userlist.component.css.map */
